import { render, staticRenderFns } from "./ViewDrafts.vue?vue&type=template&id=52b8098d"
import script from "./ViewDrafts.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDrafts.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports